<template>
    <div
        v-loading="loading"
        element-loading-text="文件正在加载，请耐心等待~"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
    >
        <div id="canvs" style="margin:0px auto;min-height:840px">
            <div class="pdf-opt">
                <div style="text-align: right">
                    <button id="prev" class="btn">上一页</button>
                    <span>
                        <span id="page_num"></span> /
                        <span id="page_count"></span>
                    </span>
                    <button id="next" class="btn">下一页</button>
                </div>
                <a style="float:right" :href="url" :download="url" target="_blank">
                    <i class="el-icon-download"></i>
                </a>
            </div>
            <canvas id="the-canvas"></canvas>
        </div>
    </div>
</template>
<script>
    import PDFJS from 'pdfjs-dist';
    export default {
        props: {
            url: {
                type: String
            }
        },
        data() {
            return {
                loading: false
            };
        },
        mounted() {
            let that = this;
            this.loading = true;
            var pdfDoc = null;
            var pageNum = 1;
            var pageRendering = false;
            var pageNumPending = null;
            var scale = 1.5;
            var canvas = document.getElementById('the-canvas');
            var ctx = canvas.getContext('2d');

            /**
             * Get page info from document, resize canvas accordingly, and render page.
             * @param num Page number.
             */
            function renderPage(num) {
                pageRendering = true;

                pdfDoc.getPage(num).then(
                    page => {
                        var viewport = page.getViewport(scale);
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        var renderContext = {
                            canvasContext: ctx,
                            viewport: viewport
                        };
                        var renderTask = page.render(renderContext);

                        renderTask.promise.then(function() {
                            pageRendering = false;
                            that.loading = false;
                            if (pageNumPending !== null) {
                                renderPage(pageNumPending);
                                pageNumPending = null;
                            }
                        });
                    },
                    err => {
                        console.error('pdf-error', err);
                        that.loading = false;
                        that.$message.error('加载失败，请稍后重试');
                    }
                );

                document.getElementById('page_num').textContent = num;
            }

            function queueRenderPage(num) {
                if (pageRendering) {
                    pageNumPending = num;
                } else {
                    renderPage(num);
                }
            }

            function onPrevPage() {
                if (pageNum <= 1) {
                    return;
                }
                pageNum--;
                queueRenderPage(pageNum);
            }
            document.getElementById('prev').addEventListener('click', onPrevPage);

            function onNextPage() {
                if (pageNum >= pdfDoc.numPages) {
                    return;
                }
                pageNum++;
                queueRenderPage(pageNum);
            }
            document.getElementById('next').addEventListener('click', onNextPage);

            PDFJS.getDocument(that.url).then(function(pdfDoc_) {
                pdfDoc = pdfDoc_;
                document.getElementById('page_count').textContent = pdfDoc.numPages;

                renderPage(pageNum);
            });
        },
        methods: {}
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .pdf-opt {
        flex-x(flex-end);
        margin: 10px;
    }

    .btn {
        margin: 0 10px;
    }

    .btn:hover {
        cursor: pointer;
    }

    #the-canvas {
        width: 100%;
        // max-width: 880px;
    }
</style>
